"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMethodToCall = exports.methodsToCall = void 0;
// Будут вызваны после загрузки скрипта
exports.methodsToCall = [];
var addMethodToCall = function (callMethod) {
    exports.methodsToCall.push(callMethod);
};
exports.addMethodToCall = addMethodToCall;
//# sourceMappingURL=methods-to-call.js.map